import React from "react";
import Layout from "../shared/components/Layout";
import SubPageBanner from "../shared/sections/SubPageBanner";
import FeedbackSection from "../shared/sections/FeedbackSection";
import ClientBannerSection from "../shared/sections/ClientBannerSection";
import DonateContent from "../shared/sections/DonateContent";

const Donate = () => {
	return (
		<Layout>
			<SubPageBanner title="We Appreciate Your Donation" />
			<DonateContent />
			<FeedbackSection />
			<ClientBannerSection noHead />
		</Layout>
	);
};

export default Donate;
